<template>
  <div class="myRequest">
    <van-tabs v-model="active">
      <van-tab :title="`全部${all ? `（${all}）` : ''}`"></van-tab>
      <van-tab
        :title="`已审批${approveDone ? `（${approveDone}）` : ''}`"
      ></van-tab>
      <van-tab :title="`不同意${no ? `（${no}）` : ''}`"></van-tab>
    </van-tabs>
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, index) in data" :key="index">
          <div class="top">
            <div>
              <div class="title" @click="goTo(item)">
                {{ item.workflowName }}
              </div>
              <div class="text">{{ item.createTime }}</div>
            </div>
            <!-- <span
              v-if="item.statusName == '审批中'"
              :style="{ color: 'rgb(86, 138, 205)' }"
              >{{ item.statusName }}</span
            > -->
            <span
              v-if="item.status == 2"
              :style="{ color: 'rgb(240, 58, 58)' }"
              >{{ item.statusName }}</span
            >
            <span v-else>{{ item.statusName }}</span>
          </div>
          <!-- <div class="van-hairline--bottom fg"></div>
        <div class="btnBox noCopy">
          <van-button @click="goTo(item)">修改提交</van-button>
        </div> -->
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      finished: false,
      active: 0,
      data: [],
      total: 0,
      all: 0,
      approveDone: 0,
      no: 0,
      searchForm: {
        pageNum: 1,
        pageRows: 10,
        type: 1,
      },
    };
  },
  watch: {
    active(newval) {
      this.finished = false;
      if (newval == 0) {
        this.searchForm.type = 1;
        this.searchForm.pageRows = 10;
        this.getData(this.searchForm);
      }
      if (newval == 1) {
        this.searchForm.type = 2;
        this.searchForm.pageRows = 10;
        this.getData(this.searchForm);
      }
      if (newval == 2) {
        this.searchForm.type = 3;
        this.searchForm.pageRows = 10;
        this.getData(this.searchForm);
      }
    },
  },
  methods: {
    onLoad() {
      this.searchForm.pageRows += 10;
      this.getData(this.searchForm);
    },
    jump() {
      this.$router.push({
        path: "/requestDetail",
      });
    },
    goTo(item) {
      let path = "";
      if (item.workflow == 0) {
        path = "/sqDetail";
      }
      if (item.workflow == 1) {
        path = "/ccDetail";
      }
      if (item.workflow == 2) {
        path = "/cityDetail";
      }
      if (item.workflow == 3) {
        path = "/lxDetail";
      }
      if (item.workflow == 4) {
        path = "/cbDetail";
      }
      if (item.workflow == 5) {
        path = "/bx5detail";
      }
      if (item.workflow == 6) {
        path = "/bx6detail";
      }
      if (item.workflow == 7) {
        path = "/bx7detail";
      }
      if (item.workflow == 8) {
        path = "/bx8detail";
      }
      if (item.workflow == 9) {
        path = "/bx9detail";
      }
      if (item.workflow == 10) {
        path = "/bx10detail";
      }
      if (item.workflow == 11) {
        path = "/bx11detail";
      }
      if (item.workflow == 12) {
        path = "/bx12detail";
      }
      if (item.workflow == 13) {
        path = "/bx13detail";
      }
      this.$router.push({
        path: path,
        query: {
          id: item.id,
          type: "detail",
          statusName: item.statusName,
        },
        name:path.split("/")[1],
        params:{
          fristEnter:true
        }
      });
    },
    getData(searchForm = {}) {
      this.$api
        .post("/payment/center/reimburse/getAppHaveTodoList", {
          reqData: {
            ...searchForm,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.list;
            this.approveDone = res.repData.list.filter(
              (item) => item.statusName == "已审批"
            ).length;
            this.no = res.repData.list.filter(
              (item) => item.statusName == "不同意"
            ).length;
            if (this.active == 0) {
              this.all = res.repData.total;
              this.approveDone = 0;
              this.no = 0;
            }
            if (this.active == 1) {
              this.all = 0;
              this.approveDone = res.repData.total;
              this.no = 0;
            }
            if (this.active == 2) {
              this.all = 0;
              this.approveDone = 0;
              this.no = res.repData.total;
            }
            this.total = res.repData.total;
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
  },
};
</script>

<style lang="scss">
.myRequest {
  height: 100%;
  display: flex;
  flex-direction: column;
  .van-tabs__line {
    width: calc(100% / 3);
  }
  .wrap {
    flex: 1;
    overflow-y: auto;
    margin-top: 10px;
    padding: 0 16px;
  }
  .item {
    width: 100%;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 20px 20px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 22px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        width: 90px;
        text-align: center;
        font-size: 14px;
      }
    }
    .title {
      color: rgb(75, 76, 75);
      margin-top: 4px;
    }
    .fg {
      margin-top: 4px;
    }
    .btnBox {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      button {
        width: 90px;
        height: 24px;
        border-radius: 30px;
        color: rgb(75, 76, 75);
        font-size: 12px;
      }
    }
  }
}
</style>